import {
    createContext,
    useContext,
    useState,
    ReactNode,
    SetStateAction,
    Dispatch,
  } from "react";
  
  import { IUserDetails } from "../EnrollTypes";
  
  
  type UserContextType = {
    User: IUserDetails | null;
    Users: IUserDetails[] | null;
    setUserContext: Dispatch<SetStateAction<IUserDetails | null>>;
    setUsersContext: Dispatch<SetStateAction<IUserDetails[] | null>>;
  };
  
  const UserContext = createContext<UserContextType | undefined>(undefined);
  
  export const UserProvider: React.FC<{ children: ReactNode }> = ({
    children,
  }) => {
    const [User, setUserContext] = useState<IUserDetails | null>(null);
    const [Users, setUsersContext] = useState<IUserDetails[] | null>(null);
  
    return (
      <UserContext.Provider
        value={{ User, Users, setUserContext, setUsersContext}}
      >
        {children}
      </UserContext.Provider>
    );
  };
  
  export const useUsers = () => {
    const context = useContext(UserContext);
    if (!context) {
      throw new Error("useUsers must be used within a UserProvider");
    }
    return context;
  };
  
  
  